import React from 'react';

const SectionIcon = ({ icon,sectionType}) => {
  return (
    <a
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
        marginTop:
          sectionType === 'yellow' ? '-40px' :
          sectionType === 'green' ? '-20px' :
          sectionType === 'zero' ? '-20px' :
          '-40px',
        left: '0%',
        zIndex: '9999',
        textAlign: 'center',
        fontWeight: 'bold',
        color: 'rgb(0, 179, 181)',
        pointerEvents: 'none',
        fontSize: '20px',
        zIndex: '3'
      }}
    >
      <img 
        src={icon}
        style={{
          maxWidth: '70px',
          maxHeight: '100px',
          objectFit: 'contain'
        }} 
        alt="Section icon" 
      />
    </a>
  );
};

export default SectionIcon;
